import getListItems from '@nike/shop-apis/buy/wishlists/v2/helpers/get-list-items';

/**
 * Gets the list items from the query client and returns a map of list items by id
 * @param {Object} queryClient - The query client
 * @returns {Object} The list items
 */
var getList = function getList(_ref) {
  var queryClient = _ref.queryClient;
  var listItemsArray = getListItems({
    queryClient: queryClient
  }) || [];
  return {
    listItems: (listItemsArray === null || listItemsArray === void 0 ? void 0 : listItemsArray.reduce(function (acc, item) {
      acc[item.id] = item;
      return acc;
    }, {})) || {}
  };
};
export default getList;